import script from "./UserPasswordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPasswordForm.vue?vue&type=script&setup=true&lang=js"

import "./UserPasswordForm.vue?vue&type=style&index=0&id=1c6cb8f6&scoped=true&lang=scss"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c6cb8f6"]])

export default __exports__